import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {Button, DialogContent, DialogTitle, IconButton, TextField} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {api} from "../../../../api/API";
import {useState} from "react";
import {PriceSectionNoteDefault} from "../../../../api/PriceSectionNotes";
import Delete from "@mui/icons-material/Delete";


export function NoteCustomizeDefault(props: {
    keyName: string;
    value: PriceSectionNoteDefault[];
    onDone(): void;
}) {

    const onDoneRef = useSyncedRef(props.onDone)
    const [list, setList] = useState(props.value);

    const action = useAsyncAction(async (input) => {
        await api.priceSectionNotes.setDefaults(input)
        onDoneRef.current();
    }, [])

    const submit = () => {
        action.callback({
            keyName: props.keyName,
            notes: list,
        })
    };

    return (
        <Dialog2 open fullWidth maxWidth="lg" onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>
                Customize Defaults
            </DialogTitle>
            <DialogContent>

                {list.map(l => (
                    <div key={l.id} style={{padding: 10, display: "flex", alignItems: "center"}}>
                        <TextField fullWidth variant="outlined" value={l.note} onChange={e => {
                            setList(list.map(old => {
                                if(l.id === old.id) {
                                    return {...old, note: e.target.value}
                                }

                                return old;
                            }))
                        }} />
                        <div style={{width: 10}} />
                        <IconButton onClick={() => {
                            setList(list.filter(v => v.id !== l.id))
                        }}>
                            <Delete />
                        </IconButton>
                    </div>
                ))}

                <Button onClick={() => {
                    setList([...list, {
                        id: -(list.length+1),
                        keyName: props.keyName,
                        note: "",
                    }])
                }}>Add Row</Button>

            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error}
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}